import { eventDispatcher } from '@optimizely/optimizely-sdk';
var eventProxy = {
  dispatchEvent: function dispatchEvent(event, callback) {
    event.url = "".concat(process.env.FRONTEND_PROXY_HOST, "/v1/events");
    eventDispatcher.dispatchEvent(event, callback);
  }
};
export default eventProxy;